<template>            
  <form class="mt-5">
    <b-alert show class="d-flex mb-4 flex-column">
      <div><span v-html="alertHeadline"/></div>
      <div><span v-html="alertSubHeadline" /></div>
    </b-alert>
    <b-alert
      :show="passwordInfo"
      dismissible
      variant="primary"
      @dismissed="passwordInfo=false"
    >
      <h6 v-html="$t('ManageIdentity.Views.Account.Register.PasswordHintHeading')" />
      <span v-html="$t('ManageIdentity.Views.Account.Register.SubHeadline')" />
    </b-alert> 
    <b-alert
      :show="!passwordIdentical"
      variant="danger"
    >
      <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorConfirmPassword')" />
    </b-alert>
    <b-alert
      :show="credentials.password.length && !passwordState"
      variant="danger"
    >
      <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorRequirementPassword')" />
    </b-alert>    
    <p>Please confirm your password below.</p>
    <!-- User Email -->
    <b-form-group
      :label="userEmail"
      label-for="user-email">
      <b-form-input
        type="email"
        :value="userData.email" 
        disabled/>
    </b-form-group>

    <!-- Password -->              
    <b-form-group
      :label="password"
      label-for="password">
      <div class="password-input-container">
        <b-form-input
            v-if="!showPassword"
            id="input-2"
            v-model="credentials.password"
            trim
            type="password"
            @keyup.enter="() => {
              if (emailState && passwordState) {
                handleLogin()
              }
            }"
        />
        <b-form-input
          v-else
          id="input-2-shown"
          v-model="credentials.password"
          trim
          type="text"
          :placeholder="password"
          @keyup.enter="() => {
            if (emailState && passwordState) {
              handleLogin()
            }
          }"
        />
        <div>
          <button v-if="!showPassword" class="btn btn-primary" @click.prevent="toggleShow">
            <font-awesome-icon :icon="['fas', 'eye-slash']" />
          </button>
          <button v-else class="btn btn-primary" @click.prevent="toggleShow">
            <font-awesome-icon :icon="['fas', 'eye']" />
          </button>
        </div>  
      </div>
    </b-form-group>
    
    <!-- Confirm Password -->
    <b-form-group
      :label="confirmPassword"
      label-for="confirmPassword">
      <div class="password-input-container">

        <b-form-input
            v-if="!showPassword"
            id="input-confirm"
            v-model="credentials.passwordConfirm"
            trim
            type="password"
            @keyup.enter="() => {
              if (emailState && passwordState) {
                handleLogin()
              }
            }"
        />
        <b-form-input
          v-else
          id="input-confirm-show"
          v-model="credentials.passwordConfirm"
          trim
          type="text"
          placeholder="Confirm Password"
          @keyup.enter="() => {
            if (emailState && passwordState) {
              handleLogin()
            }
          }"
        />

        <div>
          <button v-if="!showPassword" class="btn btn-primary" @click.prevent="toggleShow">
            <font-awesome-icon :icon="['fas', 'eye-slash']" />
          </button>
          <button v-else class="btn btn-primary" @click.prevent="toggleShow">
            <font-awesome-icon :icon="['fas', 'eye']" />
          </button>
        </div>  

      </div>             
    </b-form-group>

    <!-- Terms and conditions -->

      <!-- Check box -->
    <b-form-group>
      <b-form-checkbox
        id="checkbox-1"
        v-model="credentials.acceptTermsOfUse"
        name="checkbox-1"
      >
        <span>
          <a
            href="javascript:void(0)"
            @click="openModal(true)"
          >
            <span>{{ $t('ManageIdentity.Views.Account.Register.AcceptTerms') }}</span>
          </a>
        </span>

      </b-form-checkbox>
    </b-form-group>

      <!-- Modal -->
      <modal
      :show="termsModal.show"
      @close="termsModal.show = false"
    >
      <b-card
        class="terms-card"
      >
        <div
          class="terms-card__close-button"
          @click.prevent="termsModal.show = false"
        >
          &times;
        </div>
        <b-card-title>
          {{ $t(termsModalTitle) }}
        </b-card-title>
        <b-card-text>{{ $t('ManageIdentity.Views.Account.Terms.SubHeadline') }}</b-card-text>
        <b-tabs card>
          <b-tab
            :title="termsTitle"
            active
          >
            <b-card-text
              class="modal-text-scroll"
              v-html="tnc"
            />
          </b-tab>
          <b-tab :title="dataProtectionTitle">
            <b-card-text
              class="modal-text-scroll"
              v-html="data"
            />
          </b-tab>
          <template v-if="getConfig.context === 'Event'">
            <b-tab :title="termsTitleOrg" v-if="tncOrg">
              <b-card-text class="modal-text-scroll" v-html="tncOrg" />
            </b-tab>
            <b-tab :title="dataProtectionTitleOrg" v-if="dataOrg">
              <b-card-text class="modal-text-scroll" v-html="dataOrg" />
            </b-tab>
          </template>
        </b-tabs>
        <b-button
          variant="success"
          @click.prevent="termsModal.show = false"
        >
          {{ $t('ManageIdentity.Views.Account.Register.btnClose') }}
        </b-button>
        <!--        <b-form-checkbox-->
        <!--          id="checkbox-1"-->
        <!--          v-model="acceptTermsOfUse"-->
        <!--          name="checkbox-1"-->
        <!--        >-->
        <!--          <span>{{ $t('ManageIdentity.Views.Account.Register.AcceptTerms') }}</span>-->
        <!--        </b-form-checkbox>-->
      </b-card>
      </modal>

    <!-- End Terms and Conditions -->

    <!-- Login Error -->    
    <div v-if="error"> 
      <div class="alert alert-danger d-flex justify-content-between align-items-center">
        {{ error }}
      </div>
    </div>


    <!-- Login Btn -->
    <b-button                
      :disabled="!submitAllowedState || loading"
      class="login__box__login_btn"
      variant="primary"
      @click.prevent="confirmUser()"
    >
      <template v-if="loading">
        <span class="login__box__loader" />
      </template>
      <template v-else>
        <span v-html="$t('ManageIdentity.Views.Account.Login.btnLogin')" />
      </template>
    </b-button>


  </form>

</template>

<script>
  import accountPageMixins from '../../mixins/accountPageMixins'  
  //import axios from 'axios'
  import * as constants from '../../constants/constants'
  import utils from '~/utilities/utils'

export default {
    props: ['ssoEvaluatedUserStatusAction', 'userData', 'areTermsAccepted', 'returnUrl'],
    data() {
        return {
            credentials: {
                password: '',
                passwordConfirm: '',             
                acceptTermsOfUse: false,
            },            
            loading: false,
            showPassword: false,
            errorMsg: false  ,
            passwordInfo: true          
        }
    },
    mixins: [ accountPageMixins ],    
    computed: {
      userEmail() {
        return 'Email'
      },
      password() {
        return this.$t('ManageIdentity.Views.Account.Login.Password')
      },
      confirmPassword() {
        return 'Confirm Password'
      },
      passwordRegex() {
        return constants.passwordRegex
      },
      passwordState() {
        return this.passwordRegex.test(this.credentials.password)
      },
      confirmPasswordState() {
        return this.passwordRegex.test(this.credentials.passwordConfirm)
      },
      passwordIdentical() {
        return this.credentials.password === this.credentials.passwordConfirm
      },
      termsModalTitle() {
      return this.$t('ManageIdentity.Views.Account.Terms.Headline')
      },
      termsTitle() {
        return this.$t('ManageIdentity.Views.Account.Register.Terms')
      },
      dataProtectionTitle() {
        return this.$t('ManageIdentity.Views.Account.Register.Data')
      },
      termsTitleOrg() {
        return this.$t('ManageIdentity.Views.Account.Register.TermsCustom')
      },
      dataProtectionTitleOrg() {
        return this.$t('ManageIdentity.Views.Account.Register.DataCustom')
      },
      submitAllowedState() {
        return this.passwordState && this.passwordIdentical && this.credentials.acceptTermsOfUse
      },
      error () {        
          return this.$store.getters['singleSignOn/ssoError']        
      },
      alertHeadline() {
        if (this.ssoEvaluatedUserStatusAction == 'ExternalUserWithIdentityAndNoSSOLink') {
          return this.$t('ManageLoginComponent_AccountExternal.Headline_ExternalUserWithIdentityAndNoSSOLink')
        } else {
          return this.$t('ManageLoginComponent_AccountExternal.Headline_ExternalUserWithIdentityAndNoPassword')
        }
      },
      alertSubHeadline() {
        if (this.ssoEvaluatedUserStatusAction == 'ExternalUserWithIdentityAndNoSSOLink') {
          return this.$t('ManageLoginComponent_AccountExternal.SubHeadline_ExternalUserWithIdentityAndNoSSOLink')
        } else {
          return this.$t('ManageLoginComponent_AccountExternal.SubHeadline_ExternalUserWithIdentityAndNoPassword')
        }

      }
    },
    methods: {
      toggleShow() {
        this.showPassword = !this.showPassword
      },
      async openModal(params) {
        this.termsModal.show = true
        if (params) {
          this.loadTermsAndConditions()
          this.credentials.acceptTermsOfUse = false
        }
      },
      closeError() {
        this.error = false
      },  
      async confirmUser() {  
        this.loading = true

        if (this.ssoEvaluatedUserStatusAction == 'ExternalUserWithIdentityAndNoSSOLink') {  
          const data = {
            password: this.credentials.password,
            returnUrl: this.returnUrl
          }
          this.ssoUserConfirmPassword(data)
          .then((res) => {
            const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
            this.$router.replace(url)
          })
          .catch((err) => {
            this.loading = false          
          })
        }

        if (this.ssoEvaluatedUserStatusAction == 'ExternalUserWithIdentityAndNoPassword') {
          const pagParams = this.$store.getters['ModuleConfig/moduleConfig']?.pagParams
          const confirmUrl = `${window.location.origin}${pagParams}/auth/confirmation`
          //const redirectUrl = this.$store.getters['singleSignOn/ssoRedirectUrl']
          const redirectUrl = this.returnUrl
          const data = {
            returnUrl: redirectUrl,
            password: this.credentials.password,
            passwordConfirm: this.credentials.passwordConfirm,
            acceptTermsOfUse: this.credentials.acceptTermsOfUse,
            confirmationUrl: confirmUrl
          }
          
          this.ssoExternalRegisterAccount(data)
          .then((res) => {
            const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
            this.$router.replace(url)
          })
          .catch((err) => {
            this.loading = false          
          })
        }
      }
    }

}


</script>

<style lang="scss" scoped>
    .btn.disabled {
      cursor: not-allowed;
    }

    .login__box__login_btn {
      width: 100%;
      max-width: 200px;
      cursor: pointer;
    }

    .login__box__login_btn:disabled {
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .login__box__loader {
      width: 16px;
      height: 16px;
      border: 2px solid #FFF;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }  

</style>